// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"350fb8dc","331":"a1f76003","352":"b5ae238f","788":"174e5cff"}[chunkId] + ".chunk.js";
};